import styled from 'styled-components';
import { Poppins } from './Poppins';

export const Card = styled.div<{ $bare?: boolean; $minHeight: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${({ $minHeight }) => $minHeight}px;
  padding: 20px;
  background: ${({ theme }) => theme.colors.cultured};
  border: 1px solid ${({ theme }) => theme.colors.stroke};
  border-radius: 8px;

  ${({ $bare }) =>
    $bare &&
    `
    border: none;
    border-radius: 0;
  `}
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  max-width: 410px;
`;

export const Description = styled(Poppins)`
  line-height: 1.7;
`;
